import React from 'react'

import Login from '../pages/auth/Login'
import ForgotPassword from "../pages/auth/ForgotPassword"

import Wms from '../pages/main/wms/Index'
import Pos from '../pages/main/pos/Index'
import Units from '../pages/main/units/Index'
import Clients from '../pages/main/clients/Index'
import ClientTypes from '../pages/main/clientTypes/Index'
import Employees from '../pages/main/employees/Index'
import EmployeesTypes from '../pages/main/employeesTypes/Index'
import Roles from '../pages/main/roles/Index'
import Departments from '../pages/main/departments/Index'
import EmployeeAccount from '../pages/main/employees/Account'
import Kpi from '../pages/main/employees/Kpi'
import Attendance from '../pages/main/attendance/Index'
import Currency from '../pages/main/currency/Index'
import Suppliers from '../pages/main/suppliers/Index'
import Categories from '../pages/main/categories/Index'
import Accounts from '../pages/main/accounts/Index'
import DeliveryTypes from '../pages/main/deliveryTypes/Index'
import PaymentTypes from '../pages/main/paymentTypes/Index'
import PaymentPurposes from '../pages/main/paymentPurposes/Index'
import TelegramSettings from '../pages/main/telegramSettings/Index'
import CrmSettings from '../pages/main/crmSettings/Index'
import ChequeNoteSettings from '../pages/main/chequeNoteSettings/Index'
import Regions from '../pages/main/regions/Index'

import CashboxCheques from '../pages/main/cashbox/Index'
import Cashbox from '../pages/main/cashbox/Cashbox'
import PendingOrders from '../pages/main/cashbox/PendingOrders'

import WorkShopCheques from '../pages/workshop/cheques/Index'
import WarehouseCheques from '../pages/workshop/warehouse/Index'
import Board from '../pages/workshop/Board'

import Product from '../pages/main/products/Index'
import ProductCreateUpdate from '../pages/main/products/CreateUpdate'
import ProductStatuses from '../pages/main/productsGroupStatus/Index'

import DocumentsIn from '../pages/main/documentsIn/Index'
import DocumentsInCreateUpdate from '../pages/main/documentsIn/CreateUpdate'
import DocumentsInPreview from '../pages/main/documentsIn/Preview'

import DocumentPreparation from '../pages/main/documentsPreparation/Index'
import DocumentPreparationCreateUpdate from '../pages/main/documentsPreparation/CreateUpdate'
import DocumentPreparationPreview from '../pages/main/documentsPreparation/Preview'

import WorkshopDocumentPreparation from '../pages/workshop/documentsPreparation/Index'
import WorkshopDocumentPreparationCreateUpdate from '../pages/workshop/documentsPreparation/CreateUpdate'
import WorkshopDocumentPreparationPreview from '../pages/workshop/documentsPreparation/Preview'
import DailyWork from '../pages/workshop/DailyWork'

import WriteOff from '../pages/main/writeOff/Index'
import WriteOffCreateUpdate from '../pages/main/writeOff/CreateUpdate'
import WriteOffPreview from '../pages/main/writeOff/Preview'

import Inventory from '../pages/main/inventory/Index'
import InventoryCreateUpdate from '../pages/main/inventory/CreateUpdate'
import InventoryPreview from '../pages/main/inventory/Preview'

// Analytics
import AnalyticsDashboard from '../pages/main/analytics/Dashboard'
import DailyDashboard from '../pages/main/analytics/DailyDashboard'
import AnalyticsUnit from '../pages/main/analytics/Unit'
import ExpenseAnalysis from '../pages/main/analytics/ExpenseAnalysis'
import MonthlyReport from '../pages/main/analytics/MonthlyReport'
import CustomerAnalytics from '../pages/main/analytics/CustomerAnalytics'
import AbcProducts from '../pages/main/analytics/AbcProducts'
import Reorder from '../pages/main/analytics/Reorder'
import Frozen from '../pages/main/analytics/Frozen'
import AbcXyz from '../pages/main/analytics/AbcXyz'
import ProductionCapacity from '../pages/main/productionCapacity/Index'

// Reports
import Dashboard from '../pages/main/reports/Dashboard'
import ReportClients from '../pages/main/reports/ClientDebt'
import ReportClientsInnerDebts from '../pages/main/reports/ClientDebtInner'
import ReportSuppliers from '../pages/main/reports/Supplier'
import ReportSuppliersInner from '../pages/main/reports/SupplierInnerDebt'
import ReportBalance from '../pages/main/reports/Balance'
import ReportBalance2 from '../pages/main/reports/Balance2'
import Shifts from 'pages/main/reports/Shifts'
import ZReport from 'pages/main/reports/ZReport'
import DcoumentsIn from 'pages/main/reports/DocumentsIn'
import Summary from 'pages/main/reports/Summary'
import Expenses from 'pages/main/reports/Expenses'
import Rasxodlar from 'pages/main/reports/Rasxodlar'
import ReportGrossIncome from 'pages/main/reports/GrossIncome'
import DeletedCheques from 'pages/main/reports/DeletedCheques'
import DeletedExpenses from 'pages/main/reports/DeletedExpenses'
import ReturnsReport from 'pages/main/reports/ReturnsReport'
import DebtMonitoring from 'pages/main/reports/DebtMonitoring'

// ADMIN
import AdminPos from '../pages/admin/pos/Index'
import AdminUser from '../pages/admin/users/Index'
import AdminPayment from '../pages/admin/payments-history/Index'
import DocumentsPreparation from 'pages/main/reports/DocumentsPreparation'
import Sales from 'pages/main/reports/Sales'
import Cashiers from 'pages/main/reports/Cashiers'
import RollProfit from 'pages/main/reports/RollProfit'
import RollPrices from 'pages/main/reports/RollPrices'
import RollWarehouse from 'pages/main/reports/RollWarehouse'

export const publicRoutes = [
	{ path: "/auth/login", component: <Login /> },
	{ path: "/auth/forgot-password", component: <ForgotPassword /> },
]

export const cashierRoutes = [
	{ path: "/cashbox", component: <CashboxCheques /> },

	{ path: "/cashbox/create", component: <Cashbox /> },
	{ path: "/cashbox/edit/:id", component: <Cashbox /> },
	{ path: "/cashbox/pending-orders", component: <PendingOrders /> },
]

export const workshopRoutes = [
	{ path: "/workshop", component: <WorkShopCheques /> },
	{ path: "/workshop/board", component: <Board /> },
	{ path: "/workshop/daily-work", component: <DailyWork /> },
	{ path: "/warehouse", component: <WarehouseCheques /> },

	{ path: "/workshop/documents-preparation", component: <WorkshopDocumentPreparation /> },
	{ path: "/workshop/documents-preparation/create", component: <WorkshopDocumentPreparationCreateUpdate /> },
	{ path: "/workshop/documents-preparation/preview/:id", component: <WorkshopDocumentPreparationPreview /> },
]

export const privateRoutes = [
	{ path: "/pos", component: <Pos /> },
	{ path: "/wms", component: <Wms /> },
	{ path: "/units", component: <Units /> },
	{ path: "/clients", component: <Clients /> },
	{ path: "/clients-types", component: <ClientTypes /> },
	{ path: "/employees", component: <Employees /> },
	{ path: "/employees-types", component: <EmployeesTypes /> },
	{ path: "/roles", component: <Roles /> },
	{ path: "/departments", component: <Departments /> },
	{ path: "/employee-account", component: <EmployeeAccount /> },
	{ path: "/kpi", component: <Kpi /> },
	{ path: "/attendance", component: <Attendance /> },
	{ path: "/categories", component: <Categories /> },
	{ path: "/accounts", component: <Accounts /> },
	{ path: "/delivery-types", component: <DeliveryTypes /> },
	{ path: "/suppliers", component: <Suppliers /> },
	{ path: "/currency", component: <Currency /> },
	{ path: "/payment-types", component: <PaymentTypes /> },
	{ path: "/payment-purposes", component: <PaymentPurposes /> },
	{ path: "/telegram-settings", component: <TelegramSettings /> },
	{ path: "/crm-settings", component: <CrmSettings /> },
	{ path: "/cheque-note-settings", component: <ChequeNoteSettings /> },
	{ path: "/regions", component: <Regions /> },

	{ path: "/products", component: <Product /> },
	{ path: "/production-capacity", component: <ProductionCapacity /> },
	{ path: "/products/create", component: <ProductCreateUpdate /> },
	{ path: "/products/update/:id", component: <ProductCreateUpdate /> },
	{ path: "/product-statuses", component: <ProductStatuses /> },

	{ path: "/documents-in", component: <DocumentsIn /> },
	{ path: "/documents-in/create", component: <DocumentsInCreateUpdate /> },
	{ path: "/documents-in/preview/:id", component: <DocumentsInPreview /> },

	{ path: "/documents-preparation", component: <DocumentPreparation /> },
	{ path: "/documents-preparation/create", component: <DocumentPreparationCreateUpdate /> },
	{ path: "/documents-preparation/preview/:id", component: <DocumentPreparationPreview /> },

	{ path: "/write-off", component: <WriteOff /> },
	{ path: "/write-off/create", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/update/:id", component: <WriteOffCreateUpdate /> },
	{ path: "/write-off/preview/:id", component: <WriteOffPreview /> },

	{ path: "/inventory", component: <Inventory /> },
	{ path: "/inventory/create", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/update/:id", component: <InventoryCreateUpdate /> },
	{ path: "/inventory/preview/:id", component: <InventoryPreview /> },

	{ path: "/production-board", component: <Board /> },

	{ path: "/analytics/dashboard", component: <AnalyticsDashboard /> },
	{ path: "/analytics/unit", component: <AnalyticsUnit /> },
	{ path: "/analytics/expenses", component: <ExpenseAnalysis /> },
	{ path: "/analytics/monthly-report", component: <MonthlyReport /> },
	{ path: "/analytics/customer", component: <CustomerAnalytics /> },
	{ path: "/analytics/abc-products", component: <AbcProducts /> },
	{ path: "/analytics/reorder", component: <Reorder /> },
	{ path: "/analytics/frozen", component: <Frozen /> },
	{ path: "/analytics/abc-xyz", component: <AbcXyz /> },
	{ path: "/analytics/daily-dashboard", component: <DailyDashboard /> },

	{ path: "/report/dashboard", component: <Dashboard /> },
	{ path: "/report/shifts", component: <Shifts /> },
	{ path: "/report/z-report", component: <ZReport /> },
	{ path: "/report/documents-in", component: <DcoumentsIn /> },
	{ path: "/report/documents-preparation", component: <DocumentsPreparation /> },
	{ path: "/report/sales", component: <Sales /> },
	{ path: "/report/cashiers", component: <Cashiers /> },
	{ path: "/report/summary", component: <Summary /> },
	{ path: "/report/expenses", component: <Expenses /> },
	{ path: "/report/rasxodlar", component: <Rasxodlar /> },
	{ path: "/report/gross-income", component: <ReportGrossIncome /> },
	{ path: "/report/roll-profit", component: <RollProfit /> },
	{ path: "/report/roll-prices", component: <RollPrices /> },
	{ path: "/cashbox/pending-orders", component: <PendingOrders /> },
	{ path: "/report/deleted-cheques", component: <DeletedCheques /> },
	{ path: "/report/deleted-expenses", component: <DeletedExpenses /> },
	{ path: "/report/returns", component: <ReturnsReport /> },

	{ path: "/report-suppliers", component: <ReportSuppliers /> },
	{ path: "/report-suppliers-debts/:supplier_id", component: <ReportSuppliersInner /> },
	{ path: "/report-clients", component: <ReportClients /> },
	{ path: "/report-clients-debts/:client_id", component: <ReportClientsInnerDebts /> },
	{ path: "/report/debt-monitoring", component: <DebtMonitoring /> },
	{ path: "/report-balance", component: <ReportBalance key="balance-all" /> },
	{ path: "/report-balance-2", component: <ReportBalance2 /> },
	{ path: "/warehouse-rolls", component: <RollWarehouse /> },
	{ path: "/warehouse-products", component: <ReportBalance key="wh-products" warehouse="products" titleKey="warehouse_products" /> },
	{ path: "/warehouse-finished", component: <ReportBalance key="wh-finished" warehouse="finished" titleKey="warehouse_finished" /> },

]

export const adminPrivateRoutes = [
	// admin
	{ path: "/admin/users", component: <AdminUser /> },
	{ path: "/admin/poses", component: <AdminPos /> },
	{ path: "/admin/payments-history", component: <AdminPayment /> },
]